import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ClipboardIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Clipboard",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.95 5.44h-.35c-.35-.57-1.01-1.05-2.11-1.05h-.51C18.69 3.01 17.46 2 16 2s-2.68 1.02-2.98 2.39h-.51c-1.07 0-1.73.49-2.07 1.05h-.38c-2.6 0-4.73 2.11-4.73 4.72v15.12A4.73 4.73 0 0 0 10.06 30h11.9c2.59 0 4.72-2.11 4.72-4.72V10.15c0-2.59-2.11-4.72-4.72-4.72Zm-5.94-2.47c.75 0 1.35.61 1.35 1.35s-.61 1.35-1.35 1.35-1.35-.61-1.35-1.35.61-1.35 1.35-1.35m7.89 22.3c0 1.07-.86 1.93-1.93 1.93h-11.9c-1.07 0-1.94-.86-1.94-1.93V10.15c0-1.07.87-1.93 1.94-1.93h.05v.22c0 .6.27 1.08.62 1.08h10.52c.35 0 .62-.48.62-1.08v-.22h.08c1.07 0 1.93.86 1.93 1.93v15.12Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.29 29.28h-16c-1.89 0-3.43-1.54-3.43-3.43V5.29a1.14 1.14 0 1 1 2.28 0v20.57c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.29a1.14 1.14 0 1 1 2.28 0v20.57c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 8.71H10.57c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14H22c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14M11.71 6.43h9.14V4.14h-9.14z"
      })]
    })
  }));
};
ClipboardIcon.displayName = 'ClipboardIcon';